import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import styles from './AboutPage.module.css';

export default function AboutPage() {
  return (
    <>
      <SEO
        title="O nas — darmowy portal nieruchomości bez reklam"
        description="Nieruchomy.pl to w pełni darmowy portal ogłoszeń nieruchomości w Polsce. Bez reklam, bez ukrytych opłat. Każde ogłoszenie weryfikujemy ręcznie."
        url="https://nieruchomy.pl/o-nas"
      />
      <div className={styles.page}>

        {/* HERO */}
        <section className={styles.hero}>
          <div className={styles.heroInner}>
            <div className={styles.eyebrow}>O nas</div>
            <h1>Portal który powstał<br /><em>z frustracji</em></h1>
            <p>
              Zmęczyliśmy się portalami nieruchomości pełnymi reklam, wyróżnień za dopłatą
              i ogłoszeń od agencji zasypujących wyniki. Postanowiliśmy zrobić coś inaczej.
            </p>
          </div>
        </section>

        {/* MISJA */}
        <section className={styles.section}>
          <div className={styles.inner}>
            <div className={styles.twoCol}>
              <div>
                <h2>Nasza misja</h2>
                <p>
                  Nieruchomy.pl to portal ogłoszeniowy stworzony z jednego prostego przekonania —
                  szukanie i wystawianie nieruchomości powinno być <strong>bezpłatne i uczciwe</strong>.
                </p>
                <p>
                  Nie pobieramy opłat za wystawienie ogłoszenia. Nie sprzedajemy reklam.
                  Nie wyróżniamy tych, którzy zapłacą więcej. Każde ogłoszenie traktujemy tak samo.
                </p>
                <p>
                  Każde ogłoszenie przed publikacją przechodzi ręczną weryfikację — dbamy
                  o to, żeby na portalu pojawiały się tylko prawdziwe, rzetelne oferty.
                </p>
              </div>
              <div className={styles.pillars}>
                {[
                  { num: '0 zł', label: 'Koszt wystawienia ogłoszenia' },
                  { num: '0', label: 'Reklam na stronie' },
                  { num: '100%', label: 'Ogłoszeń weryfikowanych ręcznie' },
                  { num: '🇵🇱', label: 'Polski portal, polskie nieruchomości' },
                ].map(p => (
                  <div key={p.label} className={styles.pillar}>
                    <span className={styles.pillarNum}>{p.num}</span>
                    <span className={styles.pillarLabel}>{p.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* JAK TO DZIAŁA */}
        <section className={styles.sectionAlt}>
          <div className={styles.inner}>
            <h2 className={styles.centeredTitle}>Jak to działa</h2>
            <div className={styles.steps}>
              {[
                { n: '1', title: 'Rejestrujesz się', desc: 'Zakładasz bezpłatne konto i weryfikujesz adres e-mail.' },
                { n: '2', title: 'Dodajesz ogłoszenie', desc: 'Wypełniasz formularz, dodajesz do 3 zdjęć. Zero opłat.' },
                { n: '3', title: 'My weryfikujemy', desc: 'Każde ogłoszenie przeglądamy ręcznie przed publikacją.' },
                { n: '4', title: 'Ogłoszenie żyje', desc: 'Pojawia się w wynikach wyszukiwania i Google.' },
              ].map(s => (
                <div key={s.n} className={styles.step}>
                  <div className={styles.stepNum}>{s.n}</div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* KONTAKT */}
        <section className={styles.section}>
          <div className={styles.inner}>
            <div className={styles.contact}>
              <h2>Kontakt</h2>
              <p>Masz pytania, uwagi lub chcesz zgłosić problem? Napisz do nas.</p>
              <div className={styles.contactInfo}>
                <div className={styles.contactItem}>
                  <span className={styles.contactIcon}>✉</span>
                  <div>
                    <span className={styles.contactLabel}>E-mail ogólny</span>
                    <a href="mailto:kontakt@nieruchomy.pl">kontakt@nieruchomy.pl</a>
                  </div>
                </div>
                <div className={styles.contactItem}>
                  <span className={styles.contactIcon}>⚑</span>
                  <div>
                    <span className={styles.contactLabel}>Zgłoszenie ogłoszenia</span>
                    <a href="mailto:zgloszenia@nieruchomy.pl">zgloszenia@nieruchomy.pl</a>
                  </div>
                </div>
                <div className={styles.contactItem}>
                  <span className={styles.contactIcon}>⚖</span>
                  <div>
                    <span className={styles.contactLabel}>RODO / dane osobowe</span>
                    <a href="mailto:rodo@nieruchomy.pl">rodo@nieruchomy.pl</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className={styles.cta}>
          <div className={styles.ctaInner}>
            <h2>Gotowy/a?</h2>
            <p>Dołącz do Nieruchomy.pl i wystaw ogłoszenie za darmo.</p>
            <div className={styles.ctaButtons}>
              <Link to="/rejestracja" className={styles.ctaPrimary}>Zarejestruj się bezpłatnie</Link>
              <Link to="/ogloszenia" className={styles.ctaSecondary}>Przeglądaj ogłoszenia</Link>
            </div>
          </div>
        </section>

      </div>
    </>
  );
}
